import { render, staticRenderFns } from "./CustomersListForward.vue?vue&type=template&id=5bb599a3"
import script from "./CustomersListForward.vue?vue&type=script&lang=js"
export * from "./CustomersListForward.vue?vue&type=script&lang=js"
import style0 from "./CustomersListForward.vue?vue&type=style&index=0&id=5bb599a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports